<script>
import Layout from '@layouts/main.vue'
import ChangePasswordContainer from '@/components/settings/change-password-container.vue'

export default {
  metaInfo() {
    return {
      title: this.$route?.meta?.title,
      meta: [
        { name: 'description', content: 'The Settings Change Password page.' },
      ],
    }
  },
  components: { Layout, ChangePasswordContainer },
}
</script>

<template>
  <Layout>
    <v-row class="d-flex justify-center">
      <v-col cols="12" md="12" lg="8" xl="5">
        <BasePageHeader
          :title="$t('settings.profileChangePassword')"
          hide-actions
        />
        <ChangePasswordContainer />
      </v-col>
    </v-row>
  </Layout>
</template>
